import { jsx as _jsx } from "react/jsx-runtime";
export const SpeechBubbleXs = ({ color = 'currentColor', ...props })=>/*#__PURE__*/ _jsx("svg", {
        fill: "none",
        height: "16",
        viewBox: "0 0 16 16",
        width: "16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M13 2.75C13.9665 2.75 14.75 3.5335 14.75 4.5V10.5C14.75 11.4665 13.9665 12.25 13 12.25H11.3105L12.582 13.5264C12.8224 13.8209 12.8049 14.2557 12.5303 14.5303C12.2557 14.8049 11.8209 14.8224 11.5264 14.582L9.18945 12.25H3C2.0335 12.25 1.25 11.4665 1.25 10.5V4.5C1.25 3.5335 2.0335 2.75 3 2.75H13ZM3 4.25C2.86193 4.25 2.75 4.36193 2.75 4.5V10.5C2.75 10.6381 2.86193 10.75 3 10.75H13C13.1381 10.75 13.25 10.6381 13.25 10.5V4.5C13.25 4.36193 13.1381 4.25 13 4.25H3ZM8 7.75C8.41421 7.75 8.75 8.08579 8.75 8.5C8.75 8.91421 8.41421 9.25 8 9.25H5C4.58579 9.25 4.25 8.91421 4.25 8.5C4.25 8.08579 4.58579 7.75 5 7.75H8ZM11 5.25C11.4142 5.25 11.75 5.58579 11.75 6C11.75 6.41421 11.4142 6.75 11 6.75H5C4.58579 6.75 4.25 6.41421 4.25 6C4.25 5.58579 4.58579 5.25 5 5.25H11Z",
            fill: color
        })
    });

//# sourceMappingURL=speech-bubble-xs.js.map